import React from 'react'
import {
  View, Text, TouchableOpacity, Image, Linking, StyleSheet
} from 'react-native'
import AppContainer from './AppContainer'
import AppMain from './AppMain'
import categories from './categories'
import { subColor, white } from './_variables.scss'
import { sendAnalyticsEvent } from './google-analytics'

// 外部サイトのチャットボット
const externalChatbots = [
  {
    name: '新型コロナウイルス',
    icon: `${process.env.PUBLIC_URL}/images/button/corona.png`,
    url: 'https://dashboard17.chordship.global.fujitsu.com/mun004/index.html',
    category: 'corona',
  },
  {
    name: '自転車',
    icon: `${process.env.PUBLIC_URL}/images/button/bicycle.png`,
    url: 'https://storageoption-a229-jpe.chordship.global.fujitsu.com/bctrl133-standard/bicycle.html',
    category: 'bicycle',
  },
  {
    name: '保育',
    icon: `${process.env.PUBLIC_URL}/images/button/childcare.png`,
    url: 'https://storageoption-a229-jpe.chordship.global.fujitsu.com/bctrl133-standard/childcare.html',
    category: 'childcare',
  },
  {
    name: 'ごみ',
    icon: `${process.env.PUBLIC_URL}/images/button/19.png`,
    url: 'https://storageoption-a229-jpe.chordship.global.fujitsu.com/bctrl133-standard/refuse.html',
    category: 'refuse',
  },
  {
    name: '戸籍・住民登録',
    icon: `${process.env.PUBLIC_URL}/images/button/20.png`,
    url: 'https://storageoption-a229-jpe.chordship.global.fujitsu.com/bctrl133-standard/resident.html',
    category: 'resident',
  },
]

const Home = ({ history }) => (
  <AppContainer headerOptions={{ goBack: false }}>
    <AppMain>
      <View style={styles.guide}>
        <Text style={styles.guideText}>お問い合わせするカテゴリーを選択してください。</Text>
      </View>
      {
        // 外部サイト
        externalChatbots.map(({ name, icon, url, category }) => {
          return (
            <View key={category} style={styles.buttonContainer}>
              <TouchableOpacity
                style={[styles.button, { backgroundColor: '#f2c719' }]}
                onPress={() => {
                  sendAnalyticsEvent('chatbot', 'category:select', category)
                  Linking.openURL(url)
                }}
              >
                <Image
                  source={icon}
                  style={styles.buttonImage}
                />
                <Text style={styles.buttonText}>{name}</Text>
              </TouchableOpacity>
            </View>
          )
        })
      }
      {
        // 内部ページ
        Object.keys(categories).map((id) => {
          const category = categories[id]
          return (
            <View key={`cateogory-${id}`} style={styles.buttonContainer}>
              <TouchableOpacity
                style={styles.button}
                onPress={() => {
                  window.setTimeout(() => {
                    sendAnalyticsEvent('chatbot', 'category:select', id)
                    history.push(`/chat/${id}`)
                  }, 10)
                }}
              >
                <Image
                  source={category.buttonImage}
                  style={styles.buttonImage}
                />
                <Text style={styles.buttonText}>{category.name}</Text>
              </TouchableOpacity>
            </View>
          )
        })
      }
    </AppMain>
  </AppContainer>
)

const styles = StyleSheet.create({
  guide: {
    marginHorizontal: '10%',
    marginVertical: 20,
  },
  guideText: {
    fontSize: '120%',
  },
  buttonContainer: {
    marginVertical: 8,
  },
  button: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: subColor,
    borderRadius: 8,
  },
  buttonImage: {
    marginVertical: 8,
    marginHorizontal: 6,
    width: 64,
    height: 64,
  },
  buttonText: {
    color: white,
    fontSize: 24,
  },
})

export default Home
